export const forceHttps = (url) => {
  if (url && url.slice(0, 5) !== "https") {
    return "https:" + url;
  }
  return url;
};
